import { ControlType } from "../enums/control-type.enum";
import { OptionTypes } from '../enums/option-types.enum';
import TrueFalse = OptionTypes.TrueFalse;
import DropDownList = OptionTypes.DropDownList;
import CheckBoxList = OptionTypes.CheckBoxList;
import RadioButtonList = OptionTypes.RadioButtonList;
import Text = OptionTypes.Text;

export class ControlHelpers {

  static getControlType(optionTypeId: number): ControlType | null {

    switch (optionTypeId) {
    case TrueFalse:
      return ControlType.Boolean;

    case DropDownList:
      return ControlType.DropDownList;

    case CheckBoxList:
      return ControlType.CheckBoxList;

    case RadioButtonList:
      return ControlType.RadioButtonList;

    case Text:
      return ControlType.Text;
    }

    return null;
  }

  static isText(optionTypeId: number) {
    return this.getControlType(optionTypeId) === ControlType.Text;
  }

  static isYesNoControlType(optionTypeId: number) {
    return this.getControlType(optionTypeId) === ControlType.Boolean;
  }

  static isListTypeControl(optionTypeId: number) {
    const controlType = this.getControlType(optionTypeId);
    return controlType === ControlType.DropDownList
      || controlType === ControlType.CheckBoxList
      || controlType === ControlType.RadioButtonList;
  }
}
